

window.addEventListener('scroll', function () {
  const objects = document.querySelectorAll('.scroll-in');

  const cb = function (entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('displayed');
        observer.unobserve(entry.target);
      }
    });
  }
  const options = {
    root: null,
    rootMargin: "0px",
    threshold: 0
  }

  const io = new IntersectionObserver(cb, options);

  objects.forEach(object => {
    io.observe(object);
  });
});


window.addEventListener('DOMContentLoaded', () => {
  const objects = document.querySelectorAll('.scroll-in-img');

  const cb = function (entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {

        const target = entry.target;
        const parent = target.parentElement;

        const siblings = Array.from(parent.querySelectorAll('.scroll-in-img'));

        if (siblings.length > 1) {
          siblings.forEach((el, index) => {
            if (!el.classList.contains('displayed')) {
              el.style.setProperty('--delay', `${index * 0.35}s`);
              el.classList.add('displayed');
              observer.unobserve(el);
            }
          });
        } else {
          target.style.setProperty('--delay', '0s');
          target.classList.add('displayed');
          observer.unobserve(target);
        }
      }
    });
  };

  const options = {
   root: null,
    rootMargin: "-100px",
    threshold: 0
  };

  const io = new IntersectionObserver(cb, options);

  objects.forEach(object => {
    io.observe(object);
  });
});



window.addEventListener('DOMContentLoaded', () => {
  const objects = document.querySelectorAll('.scroll-in-img-menu');

  const cb = function (entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {

        const target = entry.target;
        const parent = target.parentElement;

        const siblings = Array.from(parent.querySelectorAll('.scroll-in-img-menu'));

        if (siblings.length > 1) {
          siblings.forEach((el, index) => {
            if (!el.classList.contains('displayed')) {
              el.style.setProperty('--delay', `${index * 0.1}s`);
              el.classList.add('displayed');
              observer.unobserve(el);
            }
          });
        } else {
          target.style.setProperty('--delay', '0s');
          target.classList.add('displayed');
          observer.unobserve(target);
        }
      }
    });
  };

  const options = {
   root: null,
    rootMargin: "-100px",
    threshold: 0
  };

  const io = new IntersectionObserver(cb, options);

  objects.forEach(object => {
    io.observe(object);
  });
});